// extracted by mini-css-extract-plugin
export default {"plugin":"styles_plugin__VS6SX"};